import axios from 'axios';
import * as types from '../constants/ActionTypes';
import Page from '../../lib/page';
import { modalChannels } from '../constants/UtilVariables';

const isLoggedIn = Page.isLoggedIn();

function requestPostChatBotEligibilityAPI() {
  return {
    type: types.REQUEST_POST_CHATBOT_ELIGIBILITY,
  };
}

function postChatBotEligibilityResponse(responseData) {
  return {
    type: types.POST_CHATBOT_ELIGIBILITY_RESPONSE,
    payload: responseData && responseData.chatBotInfo,
  };
}

function postChatBotEligibilityError() {
  return {
    type: types.POST_CHATBOT_ELIGIBILITY_ERROR,
  };
}

function postChatBotEligibleFalse() {
  return {
    type: types.POST_CHATBOT_ELIGIBILITY_FALSE,
  };
}

/**
 * calling post-chat-bot-eligibility API
 */
function postChatBotEligibility(options) {
  const optionsBody = options.postChatBotResponse ? options.postChatBotResponse : options;
  return (dispatch, getState) => {
    const state = getState();
    // Get topic from smcResultKeeper if locale is not changed.
    // If locale is changed get the topic from modal.
    const topic = ((((state || {}).smcResultKeeper || {}).topicTreeSelectResult) || (((state || {}).modal || {}).topic));
    const channel = modalChannels.chatBot;
    const { intentId, intentType, entryPoint } = optionsBody;
    dispatch(requestPostChatBotEligibilityAPI());

    const URL = `/smarthelp/post-chat-bot-eligibility?intentId=${intentId}&intentType=${intentType}&entryPoint=${entryPoint}`;
    return axios.get(URL)
      .then((response) => {
        dispatch(postChatBotEligibilityResponse(response.data));
        // if user is logged in & API returns eligible, chatBotDisplay returns true
        const chatBotDisplay = isLoggedIn && response.data && response.data.chatBotInfo && response.data.chatBotInfo.result === 'ELIGIBLE';
        /**
         * if user is loggedIn by clicking on the chatBot
         * showChat callback is for opening the chat
         * reject callback is for opening the chatBotIneligible Modal
         */
        if (chatBotDisplay && typeof options.showChat === 'function') {
          dispatch(options.showChat(topic, channel));
        } else if (!chatBotDisplay && typeof options.reject === 'function') {
          dispatch(options.reject());
        }
      })
      .catch(() => {
        dispatch(postChatBotEligibilityError());
        /**
         * if user is loggedIn by clicking on the chatBot and
         * if API returns error return reject callback which opens chatBotIneligible Modal
         */
        if (isLoggedIn && typeof options.reject === 'function') {
          dispatch(options.reject());
        }
      });
  };
}

module.exports = {
  postChatBotEligibility,
  postChatBotEligibleFalse,
};
